/* eslint-disable no-unused-vars */
import axios from "axios";
import { Magic } from "magic-sdk";
import {
  SIGN_IN,
  SIGN_IN_HASHED,
  SIGN_UP,
  REFRESH_TOKEN,
  CONFIRM_EMAIL,
  RESEND_CODE,
  VERIFY_CODE_PASS,
  VERIFY_GUEST,
  RESTORE_DATA,
  CREATE_PASSWORD,
  RESTORE_REQUEST,
  AUTO_SIGN_IN,
  SSO_SIGN_IN,
  PLAID_LINK_TOKEN,
  GET_SSO_OTP,
  SET_SSO_PASS,
  GET_SIGNUP_CODE,
  PASSWORD_LESS_SIGNIN,
  GENERATE_TOKEN_NEW_USER,
  PASSWORDLESS_SIGNIN,
  CHECK_EMAIL,
  SECURE_SIGN_UP,
  GET_HOSTED_PAGE_INFO,
  GET_WHITE_LABEL_INFO,
} from "./consts";
import config from "../../../utils/config";
import app from "@/main";
import * as CryptoJS from "crypto-js";

const BASE_URL = process.env.VUE_APP_BASE_URL || "/api";
const Decrypt = function (encrypted) {
  try {
    const passphrase =
      process.env.VUE_APP_SECRET_KEY || "dfv9345rjMCKHSMbIrbTs23ef";
    const bytes = CryptoJS.AES.decrypt(encrypted, passphrase);
    if (bytes.sigBytes === 0) {
      return null; // Decryption failed
    }
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (e) {
    return "";
  }
};

const headers = {
  isiframe: true,
};
const headersV2 = {
  isiframe: true,
  "api-version": 2,
};
const magic = new Magic(config.magic.publishableKey);
const invalidateMagicDidToken = async ({ signinResp }) => {
  try {
    if (signinResp?.invalidateSession) {
      // if user exchange is connected, invalidate didtoken
      // invalidate token --> temporary solution before magic session management customization

      await magic.user.logout();
    } else {
      const resp = await axios.get(`${BASE_URL}/banks/list`);
      const { result } = resp.data;

      if (result.banks[0]?.stockId) {
        await magic.user.logout();
        window.EventBus.emit("BANK_CONNECTED_ALERT", { isBankLinked: true });
      }
    }
  } catch (err) {
    console.error({ err });
    // silently ignore
  }
};
export default {
  async [GET_SSO_OTP]() {
    const resp = await axios.post(`${BASE_URL}/auth/sso/otp`);
    return resp.data.result;
  },
  async [SET_SSO_PASS]({ commit }, payload) {
    const resp = await axios.post(`${BASE_URL}/auth/sso/set-password`, payload);
    return resp.data.result;
  },
  async [SIGN_IN_HASHED]({ commit }, user) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "sign in" });
    const resp = await axios.post(`${BASE_URL}/auth/signin`, user, {
      headers: headersV2,
    });

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign in" });
    commit("setGuestStatus", false);
    commit("setNewTokens", resp.data.result);
    return resp.data.result;
  },
  async [SIGN_IN]({ commit }, user) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "sign in" });
    const resp = await axios.post(`${BASE_URL}/auth/login`, user, {
      headers,
    });

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign in" });
    commit("setGuestStatus", false);
    commit("setNewTokens", resp.data.result);
    return resp.data.result;
  },
  async [SSO_SIGN_IN]({ commit }, user) {
    if (user.access) {
      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign in" });

      app.prototype.$DbStorage.setItem("rocketfuel_access", user.access);
      app.prototype.$DbStorage.setItem("rocketfuel_refresh", user.refresh);
      commit("setGuestStatus", false);
      commit("setNewTokens", {
        access: user.access,
        status: user.status,
        refresh: user.refresh,
      });
      return {
        access: user.access,
        status: user.status,
        refresh: user.refresh,
      };
    }
    commit("logOut");

    commit("setUserEmail", user.email);

    return null;
  },
  async [AUTO_SIGN_IN]({ commit }, user) {
    let error = false;
    const resp = await axios
      .post(`${BASE_URL}/auth/autologin`, user, {
        headers,
      })
      .catch((err) => {
        error = true;
        // logout any previous login
        commit("logOut");
        const data = err.response?.data || null;
        if (data && data.data && data.data.email) {
          commit("setUserEmail", data.data.email);
        }
      });
    if (!error) {
      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign in" });
      app.prototype.$DbStorage.setItem(
        "rocketfuel_access",
        resp.data.result.access
      );
      app.prototype.$DbStorage.setItem(
        "rocketfuel_refresh",
        resp.data.result.refresh
      );
      commit("setGuestStatus", false);
      commit("setNewTokens", resp.data.result);
      commit("ssoUser", 1);
      return resp.data.result;
    }
    return null;
  },
  async [REFRESH_TOKEN]({ commit }) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "refresh token" });
    try {
      const resp = await axios.post(`${BASE_URL}/auth/refresh-token`);

      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "refresh token" });
      commit("setGuestStatus", false);
      commit("setNewTokens", resp.data.result);
    } catch (error) {
      console.error({ err: error?.response?.data?.message || error?.message });
    }
  },
  async [PLAID_LINK_TOKEN]({ commit }) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "plaid link token" });
    const resp = await axios.get(`${BASE_URL}/auth/link-token`);

    window.EventBus.emit("DELETE_INFO_MESSAGE", {
      message: "plaid link token",
    });
    commit("setPlaidLinkTokens", resp?.data?.result?.link_token);
  },
  async [SIGN_UP]({ commit }, payload) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "sign up" });
    const resp = await axios.post(`${BASE_URL}/auth/signup`, payload, {
      headers,
    });
    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign up" });
    commit("setGuestStatus", false);
    commit("setTemporaryTokens", resp.data.result);
    // commit('setNewTokens', resp.data.result);
    return resp.data.result;
  },
  async [SECURE_SIGN_UP]({ commit }, payload) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "sign up" });
    const resp = await axios.post(`${BASE_URL}/auth/secure/signup`, payload, {
      headers,
    });
    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign up" });
    commit("setGuestStatus", false);
    commit("setTemporaryTokens", resp.data.result);
    return resp.data.result;
  },
  // eslint-disable-next-line
  async [CONFIRM_EMAIL]({ commit }, payload) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "validate email" });
    const resp = await axios.post(`${BASE_URL}/auth/validate-email`, payload);
    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "validate email" });
    return resp.data.result;
  },
  // eslint-disable-next-line
  async [VERIFY_CODE_PASS]({ commit }, payload) {
    // payload = { userId: userId, code: ''}
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "verify code" });
    const resp = await axios.post(
      `${BASE_URL}/auth/verify-restore-request`,
      payload
    );
    commit("setRestoreData", resp.data.result.restoreData);
    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "verify code" });
    return resp.data.result;
  },
  // eslint-disable-next-line
  async [RESEND_CODE]({ commit }, payload) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "resend code" });
    const resp = await axios.post(`${BASE_URL}/auth/resend`, payload);
    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "resend code" });
    return resp.data.result;
  },
  // eslint-disable-next-line no-unused-vars
  async kycVerify({ commit }, payload) {
    await axios.post(`${BASE_URL}/kyc/verify`, payload);
  },
  async [VERIFY_GUEST]({ commit }, payload) {
    const res = await axios.post(`${BASE_URL}/auth/guest-user`, payload);
    commit("setGuestStatus", true);
    commit("setTemporaryTokens", res.data.result);
    return res;
  },
  async [RESTORE_DATA]({ commit }, userId) {
    const response = await axios.get(`${BASE_URL}/auth/restore-data`, {
      params: userId,
    });
    commit("setRestoreData", response.data.result.data);
    return response.data.result.data;
  },
  async [CREATE_PASSWORD](_, payload) {
    const response = await axios.post(
      `${BASE_URL}/auth/restore/change`,
      payload
    );
    return response;
  },
  async [RESTORE_REQUEST]({ commit }, payload) {
    const resp = await axios.post(`${BASE_URL}/auth/restore/request`, payload);
    if (resp?.data?.result?.userId) {
      commit("setUserId", resp.data.result.userId);
    }
    return resp;
  },
  async [GET_SIGNUP_CODE]({ commit }, payload) {
    const resp = await axios.post(
      `${BASE_URL}/auth/getShopperSignupCode`,
      payload
    );
    return resp.data.result;
  },
  async [PASSWORD_LESS_SIGNIN]({ commit }, payload) {
    try {
      const headersV3 = payload.headers;
      const { data } = payload;
      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "sign in" });
      const resp = await axios.post(`${BASE_URL}/passwordless/signin`, data, {
        headers: headersV3,
      });
      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign in" });
      commit("setGuestStatus", false);
      commit("setNewTokens", resp.data.result);
      return resp?.data?.result;
    } catch (err) {
      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign in" });
      throw err;
    }
  },

  async [GENERATE_TOKEN_NEW_USER]({ commit }, payload) {
    let error = false;
    const resp = await axios
      .post(`${BASE_URL}/auth/generate-token/new-user`, payload, {
        headers,
      })
      .catch((err) => {
        error = true;
        // logout any previous login
        commit("logOut");
        const data = err.response?.data || null;
        if (data && data.data && data.data.email) {
          commit("setUserEmail", data.data.email);
        }
      });

    if (error) {
      return null;
    }
    app.prototype.$DbStorage.setItem(
      "rocketfuel_access",
      resp.data.result.access
    );
    app.prototype.$DbStorage.setItem(
      "rocketfuel_refresh",
      resp.data.result.refresh
    );
    commit("setGuestStatus", false);
    commit("setNewTokens", resp.data.result);
    return resp.data.result;
  },
  async magicSIGN({ commit, state }, user) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "sign in" });
    const payload = {
      encryptedReq: user.encryptedReq,
    };
    const resp = await axios.post(`${BASE_URL}/passwordless/signin`, payload, {
      headers: { authorization: user.token },
    });

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "sign in" });

    commit("setGuestStatus", false);
    commit("setNewTokens", resp.data.result);

    if (resp.data.ok && !payload.doNotInvalidateToken) {
      // doNotInvalidateToken can be used to bypass token invalidation
      invalidateMagicDidToken({ signinResp: resp.data.result });
    }

    return resp.data.result;
  },
  async [PASSWORDLESS_SIGNIN]({ commit }, payload) {
    // for OTP use
    const didToken = await magic.auth.loginWithEmailOTP({
      email: payload.email,
    });

    window.EventBus.emit("MAGICLINK_FLOW_COMPLETE", { complete: true });
    let error = false;
    const resp = await axios
      .post(`${BASE_URL}/passwordless/signin`, payload.request, {
        headers: { ...headers, Authorization: `Bearer ${didToken}` },
      })
      .catch((err) => {
        error = true;
        // logout any previous login
        commit("logOut");
        commit("setUserEmail", payload.email);
      });

    if (error) {
      return null;
    }
    if (resp.data.ok && !payload.doNotInvalidateToken) {
      // doNotInvalidateToken can be used to bypass token invalidation
      invalidateMagicDidToken({ signinResp: resp.data.result });
    }
    app.prototype.$DbStorage.setItem(
      "rocketfuel_access",
      resp.data.result.access
    );
    app.prototype.$DbStorage.setItem(
      "rocketfuel_refresh",
      resp.data.result.refresh
    );
    commit("setGuestStatus", false);
    commit("setNewTokens", resp.data.result);
    return resp.data.result;
  },
  // this api is used to check if the user is present with a specified email
  // not in use for now in frontend can be reused later
  async [CHECK_EMAIL]({ commit }, payload) {
    const resp = await axios.post(`${BASE_URL}/auth/validate/byemail`, payload);
    return resp.data.result;
  },
  // async [GET_HOSTED_PAGE_INFO]({commit}, payload) {
  //   const resp = await axios.get(`${BASE_URL}/hosted-page?uuid=`+ payload.id);
  //   return resp.data.result;
  // },
  async [GET_HOSTED_PAGE_INFO]({ commit }, payload) {
    try {
      const resp = await axios.get(`${BASE_URL}/order-info?uuid=` + payload.id);
      const returnData = Decrypt(resp?.data?.result?.returnval);
      return { returnval: returnData };
    } catch (e) {
      console.error("🚀 ~ e:", e);
      return {};
    }
  },
  async [GET_WHITE_LABEL_INFO]({ commit }, payload) {
    const resp = await axios.get(
      `${BASE_URL}/whitelabel/id/` + payload.merchant_id
    );
    return resp.data.result;
  },
  async getOrderDetails({commit}, payload) {
    try {
      const resp = await axios.get(`${BASE_URL}/order-details?uuid=`+ payload.id);
      const returnData = Decrypt(resp?.data?.result?.returnval);
      return {hostedPageInfo: returnData?.hostedPageInfo, whiteLabelInfo: returnData?.whiteLabelInfo};
    } catch(e) {
      console.error("🚀 ~ e:", e);
      return {};
    }
  },
};
